import router from '@/router.js'
import store from '@/store/store-controller/store.js'

router.beforeEach((to,from,next) => {
    let param = null
    if(to.name == process.env.VUE_APP_ROUTER_DEPOSIT
        || to.name == process.env.VUE_APP_ROUTER_DEPOSIT_HISTORY_LIST
        || to.name == process.env.VUE_APP_ROUTER_INVOICE
        || to.name == process.env.VUE_APP_ROUTER_TOPUP)
    {
        //if(store.getters['storeI18n/getNowLanguage']==='zh-TW' || store.getters['storeI18n/getNowLanguage']==='zh-CN') {
            // 因應繁簡中新版儲值頁面(2022)網址由deposit改為topup，若還有使用舊網址也需要導到新網址
            if(to.name==process.env.VUE_APP_ROUTER_DEPOSIT) {
                param = {
                    path: process.env.VUE_APP_ROUTER_TOPUP,
                    query: to.query
                }
            }
        //}
        //else { // 非繁簡中導回首頁
        //    param = "/"
        //}
    }
    
    if(param === null)
        next()
    else
        next(param)
})

export function check()
{
    if(router.currentRoute.name == process.env.VUE_APP_ROUTER_DEPOSIT 
        || router.currentRoute.name == process.env.VUE_APP_ROUTER_DEPOSIT_HISTORY_LIST
        || router.currentRoute.name == process.env.VUE_APP_ROUTER_INVOICE
        || router.currentRoute.name == process.env.VUE_APP_ROUTER_TOPUP)
    {
        //if(store.getters['storeI18n/getNowLanguage'] !== 'zh-TW' && store.getters['storeI18n/getNowLanguage'] !== 'zh-CN') {
        //    router.push({path:'/'})
        //}
    }
}